import React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import {
  backLocationDebounced,
} from '../../../../router';
import withState from '../../../../utils/withState';


module.exports = withState((setState, self, onMount) => {
  self.close = backLocationDebounced;

  const render = self.props.data.init(setState, self, onMount);

  return (state, props) => {
    const {
      data,
    } = props;

    return (
      <div
        className={`fixed s c0 bg08 o0 dn ovxH ovyA o100.active `
          + (data.animated ? 'active ' : '')
          + (self.className || '')
        }
        style={{
          zIndex: 10 + (data.index || 0),
        }}
      >
        <div className="layoutRow fhaC fvaC w hmin rlv p10 p5@m5">
          <ButtonBase
            className="dB*2 abs*2 s"
            component="div"
            onClick={backLocationDebounced}
          />
          <div className="rlv wmax dn st-40 st0<2.active">
            {render(state)}
          </div>
        </div>
      </div>
    );
  };
});
